import { AxiosPromise } from 'axios';
import { IVisitorAgreementFormValues } from '../form';
import { instance } from '../../../../services';

const createVisitorAgreement = (
  data: IVisitorAgreementFormValues,
): AxiosPromise => instance.post('/api/visitorAgreements', data);

export default createVisitorAgreement;
